import {
  SERVICE_TYPE_ID_ROUTE_PARAM,
  VISIT_TYPE_ID_ROUTE_PARAM,
} from './routeParams';

export const DEV_TOOLS_ROUTE_PATHNAME = '/dev-tools';
export const DEV_TOOLS_SANDBOX_ROUTE_PATHNAME = `${DEV_TOOLS_ROUTE_PATHNAME}/sandbox`;
export const HOME_ROUTE_PATHNAME = '/';
export const EMAIL_ROUTE_PATHNAME = '/email';
export const PHONE_ROUTE_PATHNAME = '/phone';
export const CONFIRM_YOUR_NUMBER_ROUTE_PATHNAME = '/confirm-your-number';
export const COMPLETE_PROFILE_ROUTE_PATHNAME = '/complete-profile';
export const CREATE_PASSWORD_ROUTE_PATHNAME = '/create-password';
export const COMPLETE_BOOKING_ROUTE_PATHNAME = '/complete-booking';
export const BOOKING_CONFIRMATION_ROUTE_PATHNAME = '/booking-confirmation';
export const ID_VERIFICATION_ROUTE_PATHNAME = '/id-verification';
export const INTAKE_FORM_ROUTE_PATHNAME = '/intake-form';
export const AUTH_VALIDATE_ROUTE_PATHNAME = '/auth/validate';
export const REFILLS_ROUTE_PATHNAME = '/refills';
export const REFERRAL_ROUTE_PATHNAME = '/referral';

export const DRUG_SCREEN_ROUTE_PATHNAME = '/screening';
export const DRUG_SCREEN_UPLOAD_RESULTS_ROUTE_PATHNAME = `${DRUG_SCREEN_ROUTE_PATHNAME}/upload-results`;
export const DRUG_SCREEN_REQUEST_DRUG_SCREEN_KIT_ROUTE_PATHNAME = `${DRUG_SCREEN_ROUTE_PATHNAME}/request-kit`;
export const DRUG_SCREEN_REQUEST_LAB_FORMS_ROUTE_PATHNAME = `${DRUG_SCREEN_ROUTE_PATHNAME}/request-lab-forms`;
export const DRUG_SCREEN_KIT_CHECK_ROUTE_PATHNAME = `${DRUG_SCREEN_ROUTE_PATHNAME}/kit-check`;

export const SERVICES_ROUTE_PATHNAME = '/services';
export const SERVICES_ROUTE_SERVICE_TYPE_ID_PARAM = `${SERVICES_ROUTE_PATHNAME}/:${SERVICE_TYPE_ID_ROUTE_PARAM}?`;

export const SCHEDULE_ROUTE_PATHNAME = '/schedule';
export const SCHEDULE_ROUTE_VISIT_TYPE_ID_PARAM = `${SCHEDULE_ROUTE_PATHNAME}/:${VISIT_TYPE_ID_ROUTE_PARAM}`;

export const SCHEDULE_APPOINTMENT_TIME_PREFERENCE_ROUTE_PATHNAME = `${SCHEDULE_ROUTE_PATHNAME}/appointment-time-preference`;

export const INTAKE_QUIZ_ROUTE_PATHNAME = '/intake-quiz';
export const INTAKE_QUIZ_ROUTE_VISIT_TYPE_ID_PARAM = `${INTAKE_QUIZ_ROUTE_PATHNAME}/:${VISIT_TYPE_ID_ROUTE_PARAM}`;

export const RESCHEDULE_ROUTE_PATHNAME = '/reschedule';
export const RESCHEDULE_ROUTE_VISIT_TYPE_ID_PARAM = `${RESCHEDULE_ROUTE_PATHNAME}/:${VISIT_TYPE_ID_ROUTE_PARAM}`;

export const CHAT_WIDGET_NATIVE_WEBVIEW_ROUTE_PATHNAME =
  '/chat-widget-native-webview';
